import { Grid, useMediaQuery, useTheme } from "@mui/material";
import CustomPanel from "../../CustomPanel";
import ClientPanel from "../ClientInformation/ClientPanel";
import { Vocabulary } from "../../../Utils/Vocabulary";
import { Fragment } from "react/jsx-runtime";
import { GeneralInfoTabProps, PaymentFormType } from "../../../Utils/Types";
import styles from "../../../Styles/order.module.css";
import HoursPanel from "../HoursPanel";
import MessagesPanel from "../MessagesPanel";
import withRole from "../../../Hooks/withRole";
import PaymentsListTable from "../Tables/PaymentsListTable";
import { useEffect, useRef } from "react";
import ExamnsTable from "../Tables/ExamnsTable";
import InstructorPayments from "../Tables/InstructorPayments";
import ModalButton from "../../ModalButton";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import { FormsIds } from "../../../Utils/Constants";
import PaymentForm from "../../Payments/PaymentForm";
import ClientBooks from "../../Books/ClientBooks";
import DocumentsManager from "../../Documents/DocumentsManager";

function GeneralInfo(props: GeneralInfoTabProps) {
  //const { users, instructors, managements, products } = props;
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  const {
    register,
    control,
    getValues,
    formState,
    setValue,
    watch,
    clearErrors,
    trigger,
  } = props.formData;
  const {
    saveOrder,
    instructors,
    getOrder,
    products,
    allDocumentTypes,
    triggerReload,
    setTriggerReload,
    clientDocuments,
    setClientDocuments,
    hasReadiness,
    readinessProgress,
    clientReadinessData,
  } = props;

  useEffect(() => {
    if (triggerReload === undefined) return;
    getOrder();
  }, [triggerReload]);

  const handleDocumentSaved = () => {
    setTriggerReload(!triggerReload);
  };

  const formRef = useRef<HTMLFormElement>(null);

  const supplementaryHoursPrices = getValues(
    "product.supplementaryHoursPrices",
  );
  const supplementaryHourPrice = supplementaryHoursPrices?.find(
    (price: any) =>
      price?.workPointId === getValues("client_id.workPointId._id") ||
      price?.workPointId?._id === getValues("client_id.workPointId._id"),
  )?.price;

  // Right column content panels
  const hoursPanel = (
    <CustomPanel title={Vocabulary.suplimentaryHours}>
      {/* ORELE DE CONDUS */}
      <div className={styles.productPanelContainer}>
        <HoursPanel
          nrOfDrivingHours={getValues("nrOfDrivingHours") || 0}
          nrOfSupplimentaryHours={
            getValues("product.defaultDrivingHours") +
              (getValues("supplementaryHours") || 0) || 0
          }
          instructors={instructors}
          setTriggerReload={setTriggerReload}
          triggerReload={triggerReload}
          instructorId={getValues("instructor_id")}
          name="HoursPanel"
          clientId={getValues("client_id._id")}
          supplementaryHourPrice={supplementaryHourPrice}
          vehicleId={getValues("vehicle_id")}
        />
      </div>
    </CustomPanel>
  );

  const documentsPanel = (
    <CustomPanel title={Vocabulary.documents}>
      {getValues("client_id._id") && (
        <DocumentsManager
          name="DocumentsManager"
          clientId={getValues("client_id._id")}
          orderId={getValues("_id")}
          clientData={getValues("client_id")}
          productData={getValues("product")}
          orderTypeId={(() => {
            const typeId =
              getValues("status.typeId") || getValues("status")?.typeId;
            if (!typeId) return "";
            if (typeof typeId === "string") return typeId;
            return typeId._id || "";
          })()}
          clientDocuments={clientDocuments || []}
          setClientDocuments={setClientDocuments}
          triggerReload={triggerReload}
          setTriggerReload={setTriggerReload}
        />
      )}
    </CustomPanel>
  );

  const messagesPanel = (
    <CustomPanel title={Vocabulary.messages}>
      <Fragment>
        <MessagesPanel triggerReload={triggerReload} />
      </Fragment>
    </CustomPanel>
  );

  // Right column content - wrapped for mobile, unwrapped for desktop
  const rightColumnContent = isMobileOrTablet ? (
    <>
      <div className={styles.messagesContainer}>{hoursPanel}</div>
      <div className={styles.messagesContainer}>{documentsPanel}</div>
      <div className={styles.messagesContainer}>{messagesPanel}</div>
    </>
  ) : (
    <>
      {hoursPanel}
      <div className={styles.messagesContainer}>{documentsPanel}</div>
      <div className={styles.messagesContainer}>{messagesPanel}</div>
    </>
  );

  return (
    <>
      <Grid item xs={12} sm={12} md={5} className={styles.grid}>
        <CustomPanel title={Vocabulary.clientDetails}>
          <ClientPanel
            name={"ClientPanel"}
            register={register}
            control={control}
            setValue={setValue}
            getValues={getValues}
            watch={watch}
            clearErrors={clearErrors}
            formState={formState}
            saveOrder={async () => {
              await saveOrder();
              setTriggerReload(!triggerReload);
            }}
            products={products}
            instructors={instructors}
            allDocumentTypes={allDocumentTypes}
            trigger={trigger}
            triggerReload={triggerReload}
            setTriggerReload={setTriggerReload}
            clientDocuments={clientDocuments}
            onDocumentSaved={handleDocumentSaved}
            hasReadiness={hasReadiness}
            readinessProgress={readinessProgress}
            clientReadinessData={clientReadinessData}
          />
        </CustomPanel>

        {/* Show right column content here on mobile/tablet */}
        {isMobileOrTablet && rightColumnContent}

        <div className={styles.messagesContainer}>
          <CustomPanel title={Vocabulary.instructorsPayment}>
            {/* TABEL CU SALRIUL INSTRUCTORULUI */}
            {props?.accessPayments && (
              <ModalButton
                buttonTitle={Vocabulary.salaries}
                buttonIcon={<LocalAtmIcon />}
                buttonColor="error"
                buttonSize="medium"
                formId={FormsIds.salaryForm}
                formRef={formRef}
                triggerOnClose={triggerReload}
                content={
                  <PaymentForm
                    instructor={getValues("instructor_id")}
                    workPoint={getValues("client_id.workPointId")}
                    onClose={() => setTriggerReload(!triggerReload)}
                    formRef={formRef}
                    paymentType={PaymentFormType.SALARY}
                    name="PaymentForm"
                  />
                }
              />
            )}
            {getValues("instructor_id.user_id._id") && (
              <InstructorPayments
                triggerReload={triggerReload}
                instructorId={getValues("instructor_id.user_id._id")}
              />
            )}
          </CustomPanel>
        </div>
        {props?.accessPayments && (
          <div className={styles.messagesContainer}>
            <CustomPanel title={Vocabulary.clientPayments}>
              {/* TABEL CU PLATI */}
              <PaymentsListTable triggerReload={triggerReload} />
            </CustomPanel>
          </div>
        )}
        <div className={styles.messagesContainer}>
          <CustomPanel title={Vocabulary.examList}>
            {/* TABEL CU EXAMENE */}
            {getValues("product") && (
              <ExamnsTable
                triggerReload={triggerReload}
                product={getValues("product")}
                clientId={getValues("client_id._id")}
              />
            )}
          </CustomPanel>
        </div>
        {props?.accessBooks && getValues("client_id._id") && (
          <div className={styles.messagesContainer}>
            <CustomPanel title={Vocabulary.booksList}>
              {/* TABEL CU CARTI */}
              <ClientBooks
                clientId={getValues("client_id._id")}
                triggerReload={triggerReload}
              />
            </CustomPanel>
          </div>
        )}
      </Grid>
      <Grid item xs={12} sm={12} md={7} className={styles.grid}>
        {/* Show right column content here on desktop */}
        {!isMobileOrTablet && rightColumnContent}
      </Grid>
    </>
  );
}

export default withRole(GeneralInfo);
